import pick from 'lodash/pick';
import { storableError } from '../util/errors';
import * as log from '../util/log';
import { handleCardSetup } from './stripe.duck';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/paymentMethods/SET_INITIAL_VALUES';

export const SETUP_INTENT_REQUEST = 'app/PaymentMethodsPage/SETUP_INTENT_REQUEST';
export const SETUP_INTENT_SUCCESS = 'app/PaymentMethodsPage/SETUP_INTENT_SUCCESS';
export const SETUP_INTENT_ERROR = 'app/PaymentMethodsPage/SETUP_INTENT_ERROR';

export const CREATE_STRIPE_CUSTOMER_REQUEST = 'app/paymentMethods/CREATE_STRIPE_CUSTOMER_REQUEST';
export const CREATE_STRIPE_CUSTOMER_SUCCESS = 'app/paymentMethods/CREATE_STRIPE_CUSTOMER_SUCCESS';
export const CREATE_STRIPE_CUSTOMER_ERROR = 'app/paymentMethods/CREATE_STRIPE_CUSTOMER_ERROR';

export const ADD_PAYMENT_METHOD_REQUEST = 'app/paymentMethods/ADD_PAYMENT_METHOD_REQUEST';
export const ADD_PAYMENT_METHOD_SUCCESS = 'app/paymentMethods/ADD_PAYMENT_METHOD_SUCCESS';
export const ADD_PAYMENT_METHOD_ERROR = 'app/paymentMethods/ADD_PAYMENT_METHOD_ERROR';

export const DELETE_PAYMENT_METHOD_REQUEST = 'app/paymentMethods/DELETE_PAYMENT_METHOD_REQUEST';
export const DELETE_PAYMENT_METHOD_SUCCESS = 'app/paymentMethods/DELETE_PAYMENT_METHOD_SUCCESS';
export const DELETE_PAYMENT_METHOD_ERROR = 'app/paymentMethods/DELETE_PAYMENT_METHOD_ERROR';

export const SAVE_PAYMENT_METHOD_SUCCESS = 'app/paymentMethods/SAVE_PAYMENT_METHOD_SUCCESS';

// ================ Reducer ================ //

const initialState = {
  addPaymentMethodInProgress: null,
  addPaymentMethodError: null,
  deletePaymentMethodInProgress: null,
  deletePaymentMethodError: null,
  createStripeCustomerInProgress: null,
  createStripeCustomerError: null,
  stripeCustomer: null,
};

export default function payoutMethodsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };
    case CREATE_STRIPE_CUSTOMER_REQUEST:
      return { ...state, createStripeCustomerError: null, createStripeCustomerInProgress: true };
    case CREATE_STRIPE_CUSTOMER_SUCCESS:
      return {
        ...state,
        createStripeCustomerInProgress: false,
        stripeCustomer: payload,
      };
    case CREATE_STRIPE_CUSTOMER_ERROR:
      console.error(payload);
      return {
        ...state,
        createStripeCustomerError: payload,
        createStripeCustomerInProgress: false,
      };
    case ADD_PAYMENT_METHOD_REQUEST:
      return { ...state, addPaymentMethodError: null, addPaymentMethodInProgress: true };
    case ADD_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        addPaymentMethodInProgress: false,
        stripeCustomer: payload,
      };
    case ADD_PAYMENT_METHOD_ERROR:
      console.error(payload);
      return {
        ...state,
        addPaymentMethodError: payload,
        addPaymentMethodInProgress: false,
      };

    case DELETE_PAYMENT_METHOD_REQUEST:
      return { ...state, deletePaymentMethodError: null, deletePaymentMethodInProgress: true };
    case DELETE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        deletePaymentMethodInProgress: false,
      };
    case DELETE_PAYMENT_METHOD_ERROR:
      console.error(payload);
      return {
        ...state,
        deletePaymentMethodError: payload,
        deletePaymentMethodInProgress: false,
      };
    case SAVE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //
export const setupIntentRequest = () => ({ type: SETUP_INTENT_REQUEST });
export const setupIntentSuccess = setupIntent => ({ type: SETUP_INTENT_SUCCESS, payload: setupIntent });
export const setupIntentError = error => ({ type: SETUP_INTENT_ERROR, payload: error, error: true });
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const stripeCustomerCreateRequest = () => ({ type: CREATE_STRIPE_CUSTOMER_REQUEST });

export const stripeCustomerCreateSuccess = stripeCustomer => ({
  type: CREATE_STRIPE_CUSTOMER_SUCCESS,
  payload: stripeCustomer,
});

export const stripeCustomerCreateError = e => ({
  type: CREATE_STRIPE_CUSTOMER_ERROR,
  payload: e,
  error: true,
});

export const addPaymentMethodRequest = () => ({ type: ADD_PAYMENT_METHOD_REQUEST });

export const addPaymentMethodSuccess = stripeCustomer => ({
  type: ADD_PAYMENT_METHOD_SUCCESS,
  payload: stripeCustomer,
});

export const addPaymentMethodError = e => ({
  type: ADD_PAYMENT_METHOD_ERROR,
  payload: e,
  error: true,
});

export const deletePaymentMethodRequest = () => ({ type: DELETE_PAYMENT_METHOD_REQUEST });

export const deletePaymentMethodSuccess = stripeCustomer => ({
  type: DELETE_PAYMENT_METHOD_SUCCESS,
  payload: stripeCustomer,
});

export const deletePaymentMethodError = e => ({
  type: DELETE_PAYMENT_METHOD_ERROR,
  payload: e,
  error: true,
});

export const savePaymentMethodSuccess = (listing) => ({ type: SAVE_PAYMENT_METHOD_SUCCESS, payload: listing })

// ================ Thunks ================ //

export const createStripeCustomer = stripePaymentMethodId => (dispatch, getState, sdk) => {
  dispatch(stripeCustomerCreateRequest());
  return sdk.stripeCustomer
    .create({ stripePaymentMethodId }, { expand: true, include: ['defaultPaymentMethod'] })
    .then(response => {
      const stripeCustomer = response.data.data;
      dispatch(stripeCustomerCreateSuccess(stripeCustomer));
      return stripeCustomer;
    })
    .catch(e => {
      log.error(storableError(e), 'create-stripe-user-failed');
      dispatch(stripeCustomerCreateError(storableError(e)));
    });
};

export const addPaymentMethod = stripePaymentMethodId => (dispatch, getState, sdk) => {
  dispatch(addPaymentMethodRequest());
  return sdk.stripeCustomer
    .addPaymentMethod({ stripePaymentMethodId }, { expand: true })
    .then(response => {
      const stripeCustomer = response.data.data;
      dispatch(addPaymentMethodSuccess(stripeCustomer));
      return stripeCustomer;
    })
    .catch(e => {
      log.error(storableError(e), 'add-payment-method-failed');
      dispatch(addPaymentMethodError(storableError(e)));
    });
};

export const deletePaymentMethod = () => (dispatch, getState, sdk) => {
  dispatch(deletePaymentMethodRequest());
  return sdk.stripeCustomer
    .deletePaymentMethod({}, { expand: true })
    .then(response => {
      const stripeCustomer = response.data.data;
      dispatch(deletePaymentMethodSuccess(stripeCustomer));
      return stripeCustomer;
    })
    .catch(e => {
      log.error(storableError(e), 'add-payment-method-failed');
      dispatch(deletePaymentMethodError(storableError(e)));
    });
};

export const updatePaymentMethod = stripePaymentMethodId => (dispatch, getState, sdk) => {
  return dispatch(deletePaymentMethod())
    .then(() => {
      return dispatch(addPaymentMethod(stripePaymentMethodId));
    })
    .catch(e => {
      log.error(storableError(e), 'updating-payment-method-failed');
    });
};
export const createStripeSetupIntent = (customerId = null) => (dispatch, getState, sdk) => {
  dispatch(setupIntentRequest());
  // If customer exists, pass it to the SetupIntent so the PaymentMethod is automatically attached
  const params = customerId ? { customer: customerId } : {};
  return sdk.stripeSetupIntents
    .create(params)
    .then(response => {
      const setupIntent = response.data.data;
      dispatch(setupIntentSuccess(setupIntent));
      return setupIntent;
    })
    .catch(e => {
      const error = storableError(e);
      log.error(error, 'create-setup-intent-failed');
      dispatch(setupIntentError(error));
      return { createStripeSetupIntentSuccess: false };
    });
};

// Thunk to set up a card using Stripe SetupIntent flow and save the payment method
export const setUpCardOnExternalIntent = (params) => (dispatch, getState, sdk) => {
  try {
    // Destructure required values from params
    const { stripe, card, billingDetails, currentUser } = params;
    const stripeCustomer = currentUser.stripeCustomer;

    // ---------------------------------------------
    // Step 1: Create a SetupIntent from your backend
    // ---------------------------------------------
    // This will prepare Stripe to attach a payment method securely
    // Pass Stripe customer ID if it exists so the PaymentMethod is automatically attached
    // Note: stripeCustomer.id is the marketplace entity ID, not the Stripe customer ID
    // We need stripeCustomer.attributes.stripeCustomerId for Stripe API calls
    const customerId = stripeCustomer?.attributes?.stripeCustomerId || null;
    return dispatch(createStripeSetupIntent(customerId))
      .then((setupIntent) => {
        // Check if SetupIntent creation failed
        if (!setupIntent || !setupIntent.attributes || setupIntent.createStripeSetupIntentSuccess === false) {
          const error = new Error('Failed to create SetupIntent');
          console.error('SetupIntent creation failed:', setupIntent);
          return Promise.reject(error);
        }
        // ---------------------------------------------
        // Step 2: Confirm the card setup with Stripe.js
        // ---------------------------------------------
        // Prepare payment method details to pass to Stripe
        const paymentParams = {
          payment_method_data: {
            billing_details: billingDetails,
          },
        };
        const stripeParams = {
          stripe,
          card,
          setupIntentClientSecret: setupIntent.attributes.clientSecret,
          paymentParams,
        };
        return dispatch(handleCardSetup(stripeParams))
      })
      .then(result => {
        // ---------------------------------------------
        // Step 3: Save the new payment method
        // ---------------------------------------------
        // Validate that result contains setupIntent with payment_method
        if (!result || !result.setupIntent || !result.setupIntent.payment_method) {
          const error = new Error('Invalid SetupIntent result: missing payment_method');
          console.error('SetupIntent result validation failed:', result);
          return Promise.reject(error);
        }
        // Extract payment method ID from Stripe result
        const newPaymentMethod = result.setupIntent.payment_method;
        // Note: stripe.handleCardSetup might return an error inside successful call (200), but those are rejected in thunk functions.
        return dispatch(savePaymentMethod(stripeCustomer, newPaymentMethod));
      })
      .then((res) => {
        // Check if the result contains errors
        if (res && res.errors) {
          console.error('Error in setUpCardOnExternalIntent:', res.errors);
          return Promise.reject(res);
        }
        return res;
      })
      .catch(e => {
        console.error('Error in setUpCardOnExternalIntent:', e);
        return Promise.reject(e);
      })
  }
  catch (e) {
    console.error('Error in setUpCardOnExternalIntent:', e);
    return Promise.reject(e);
  }
}

// This function helps to choose correct thunk function
export const savePaymentMethod = (stripeCustomer, stripePaymentMethodId, listing) => (
  dispatch,
  getState,
  sdk
) => {

  const hasAlreadyDefaultPaymentMethod =
    stripeCustomer && stripeCustomer.defaultPaymentMethod && stripeCustomer.defaultPaymentMethod.id;

  const savePromise =
    !stripeCustomer || !stripeCustomer.id
      ? dispatch(createStripeCustomer(stripePaymentMethodId))
      : hasAlreadyDefaultPaymentMethod
        ? dispatch(updatePaymentMethod(stripePaymentMethodId))
        : dispatch(addPaymentMethod(stripePaymentMethodId));

  return savePromise
    .then(response => {
      const {
        createStripeCustomerError,
        addPaymentMethodError,
        deletePaymentMethodError,
      } = getState().paymentMethods;

      // If there are any errors, return those errors
      if (createStripeCustomerError || addPaymentMethodError || deletePaymentMethodError) {
        return {
          errors: { createStripeCustomerError, addPaymentMethodError, deletePaymentMethodError },
        };
      }
      dispatch(savePaymentMethodSuccess(listing));
      return response;
    })
    .catch(e => {
      // errors are already catched in other thunk functions.
      // Return error object so caller can check for errors
      return {
        errors: { savePaymentMethodError: e },
      };
    });
};
